import { styled, css } from '../../../../modules';
import { keyframes } from 'styled-components';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
    padding: 28px 20px 24px;
    gap: 20px;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 24px;
    font-weight: 600;
    color: ${({ $color }) => $color};
    margin: 0;
    text-align: center;
    line-height: 1.3;
`;

export const DataCardContainer = styled.div`
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #edf2f7;
    border-radius: 12px;
`;

export const DataRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #edf2f7;

    &:last-child {
        border-bottom: none;
    }
`;

export const RowLabel = styled.span`
    font-size: 13px;
    font-weight: 400;
    color: #718096;
    flex: 1;
    padding-right: 8px;
`;

export const RowValue = styled.span<{ $color: string; $bold?: boolean }>`
    font-size: 13px;
    font-weight: ${({ $bold }) => ($bold ? 700 : 600)};
    color: ${({ $color }) => $color};
    text-align: right;
`;

export const InfoCallout = styled.div<{ $color: string }>`
    width: 100%;
    background-color: ${({$color}) => $color}22;
    border-radius: 8px;
    border: 1px solid ${({$color}) => $color}55;
    padding: 12px 14px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: flex-start;
`;

export const IconWrapper = styled.div<{ $color: string }>`
    color: ${({ $color }) => $color};
`;

export const InfoIcon = styled.div<{ $color: string }>`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
`;

export const InfoText = styled.p<{ $color: string }>`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.5;

    a {
        color: ${({ $color }) => $color};
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const CheckboxWrapper = styled.div`
    width: 100%;
`;

export const IntroCard = styled.div<{ $color: string }>`
    width: 100%;
    border: 1px solid ${({ $color }) => $color}55;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: linear-gradient(
        180deg,
        ${({ $color }) => $color}22 0%,
        #ffffff 100%
    );
`;

export const IntroHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
`;

export const IntroIconWrapper = styled.div<{ $color: string }>`
    flex-shrink: 0;
    color: ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IntroTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const IntroTitle = styled.h2<{ $color: string }>`
    font-size: 20px;
    font-weight: 700;
    color: ${({ $color }) => $color};
    margin: 0;
    line-height: 1.25;
`;

export const IntroSubtitle = styled.span`
    font-size: 12px;
    color: #718096;
    line-height: 1.4;
`;

export const IntroBody = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.5;

    strong {
        font-weight: 700;
        color: #2d3748;
    }
`;

export const ImpactCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
`;

export const ImpactTitle = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: #718096;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 14px 16px;
    border-bottom: 1px solid #edf2f7;
`;

export const ImpactRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
`;

export const ImpactLabel = styled.span`
    font-size: 14px;
    color: #4a5568;
`;

export const ImpactValue = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
`;

export const ImpactHighlightRow = styled.div<{ $color: string }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background: linear-gradient(
        180deg,
        ${({ $color }) => $color}22 0%,
        ${({ $color }) => $color}11 100%
    );
    border-top: 1px solid ${({ $color }) => $color}33;
`;

export const ImpactHighlightLabelBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const ImpactHighlightLabel = styled.span<{ $color: string }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $color }) => $color};
`;

export const ImpactHighlightDiff = styled.span<{ $color: string }>`
    font-size: 12px;
    color: ${({ $color }) => $color};
    opacity: 0.85;
`;

export const ImpactHighlightValue = styled.span<{ $color: string }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $color }) => $color};
`;

export const InsuranceTermsCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const InsuranceTermsTitle = styled.span`
    font-size: 12px;
    font-weight: 700;
    color: #718096;
    letter-spacing: 0.04em;
    text-transform: uppercase;
`;

export const InsuranceTermsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const TermLink = styled.a<{$color: string}>`
    color: ${({ $color }) => $color} !important;
    text-decoration: underline !important;
    cursor: pointer;
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 20px;
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    flex-shrink: 0;
`;

export const SubmitButton = styled.button<{ $backgroundColor: string; $disabled: boolean }>`
    width: 100%;
    padding: 16px 20px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: ${({ $backgroundColor, $disabled }) => ($disabled ? '#cbd5e0' : $backgroundColor)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`;

export const OutlineButton = styled.button<{ $color: string; $disabled: boolean }>`
    width: 100%;
    padding: 15px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    background-color: ${({ $color, $disabled }) => $disabled ? '#fff' : `${$color}33`};
    border: 1px solid ${({ $color, $disabled }) => ($disabled ? '#e2e8f0' : $color)};
    color: ${({ $color, $disabled }) => ($disabled ? '#a0aec0' : $color)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.85;
    }
`;

export const HintText = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    color: #718096;
    text-align: center;
    line-height: 1.4;
`;

export const ConfirmModalText = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.5;

    strong {
        font-weight: 700;
        color: #2d3748;
    }
`;

export const ConfirmModalHint = styled.p`
    font-size: 11px;
    color: #718096;
    margin: 0;
    line-height: 1.4;
`;

export const ConfirmModalTable = styled.div<{ $color: string }>`
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    background: linear-gradient(
        180deg,
        ${({ $color }) => $color}1A 0%,
        ${({ $color }) => $color}0D 100%
    );
    border: 1px solid ${({ $color }) => $color}33;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
`;

export const ConfirmModalRow = styled.div<{ $divider?: boolean; $color: string }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 14px;
    border-top: ${({ $divider, $color }) => ($divider ? `1px solid ${$color}22` : 'none')};
`;

export const ConfirmModalRowLabel = styled.span<{ $bold?: boolean }>`
    font-size: 13px;
    font-weight: ${({ $bold }) => ($bold ? 700 : 400)};
    color: #2d3748;
`;

export const ConfirmModalRowValue = styled.span<{ $color: string; $bold?: boolean }>`
    font-size: 13px;
    font-weight: ${({ $bold }) => ($bold ? 700 : 600)};
    color: ${({ $color }) => $color};
`;

export const HintIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #a0aec0;
    color: #a0aec0;
    font-size: 10px;
    font-weight: 600;
    font-style: italic;
    flex-shrink: 0;
`;

// ── Bottom sheet ──────────────────────────────────────────

const fadeIn = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;

const fadeOut = keyframes`
    from { opacity: 1; }
    to   { opacity: 0; }
`;

const slideUp = keyframes`
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
`;

const slideDown = keyframes`
    from { transform: translateY(0); }
    to   { transform: translateY(100%); }
`;

export const ModalOverlay = styled.div<{ $closing?: boolean }>`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 100;
    ${({ $closing }) =>
        $closing
            ? css`animation: ${fadeOut} 0.3s ease forwards;`
            : css`animation: ${fadeIn} 0.3s ease forwards;`}
`;

export const ModalSheet = styled.div<{ $closing?: boolean }>`
    background: #ffffff;
    border-radius: 20px 20px 0 0;
    padding: 28px 24px 36px;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    max-height: 80vh;
    overflow-y: auto;
    overscroll-behavior: contain;
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${({ $closing }) =>
        $closing
            ? css`animation: ${slideDown} 0.3s ease forwards;`
            : css`animation: ${slideUp} 0.3s ease forwards;`}
`;

export const SheetHandle = styled.div`
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background-color: #ddd;
    align-self: center;
    margin-bottom: 4px;
    flex-shrink: 0;
`;

export const ModalTitle = styled.h2<{ $color: string }>`
    font-size: 20px;
    font-weight: 700;
    color: ${({ $color }) => $color};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin: 0;
`;

export const ModalText = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.6;
    text-align: center;
    ul {
        text-align: start;
    }
`;

export const ModalButtonRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 4px;
`;

// ── Insurance section ────────────────────────────────────

export const InsurancePremiumCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
`;

export const InsurancePremiumLabel = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: #4a5568;
`;

export const InsurancePremiumValue = styled.span<{ $color: string }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $color }) => $color};
`;

export const CollapsibleHeader = styled.div<{ $borderBottom?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background: none;
    border: none;
    cursor: pointer;
    border-bottom: ${({ $borderBottom }) => ($borderBottom ? '1px solid #edf2f7' : 'none')};
`;

export const CollapsibleTitle = styled.span<{$color: string}>`
    font-size: 15px;
    font-weight: 600;
    color: ${({ $color }) => $color};
`;

export const ChevronIcon = styled.span<{ $open: boolean }>`
    display: flex;
    align-items: center;
    transition: transform 0.25s ease;
    transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
    color: #718096;
`;

export const CollapsibleContent = styled.div<{ $open: boolean }>`
    display: grid;
    grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
    transition: grid-template-rows 0.3s ease;

    > div {
        overflow: hidden;
    }
`;

export const CollapsibleBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 16px 14px;
`;

export const CollapsibleCard = styled.div`
    width: 100%;
    border: 1px solid #edf2f7;
    border-radius: 12px;
`;

export const CoverageItem = styled.div`
    padding: 12px 16px;
    border-bottom: 1px solid #edf2f7;

    &:last-child {
        border-bottom: none;
    }
`;

export const CoverageTitle = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #2d3748;
    display: block;
`;

export const CoverageDescription = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: #718096;
    display: block;
    margin-top: 2px;
`;

export const CoverageTopicsList = styled.ul`
    list-style: disc;
    margin: 6px 0 0;
    padding-left: 18px;
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const CoverageTopicItem = styled.li`
    font-size: 12px;
    color: #4a5568;
    line-height: 1.4;
`;

export const CoverageTopicLabel = styled.span`
    font-weight: 600;
    color: #2d3748;
`;

export const CoverageTopicText = styled.span`
    font-weight: 400;
    color: #718096;
`;

export const BenefitItem = styled.div`
    padding: 12px 16px;
`;

export const BenefitText = styled.span<{ $color: string }>`
    font-size: 13px;
    color: #4a5568;

    strong {
        color: ${({ $color }) => $color};
        font-weight: 700;
    }
`;

export const AccountTermIntro = styled.p`
    font-size: 13px;
    color: #4a5568;
    margin: 10px 0;
    line-height: 1.5;

    strong {
        font-weight: 700;
    }
`;

export const AccountTermItem = styled.div`
    margin-bottom: 10px;
`;

export const AccountTermLabel = styled.span`
    font-size: 13px;
    font-weight: 700;
    color: #2d3748;
    display: block;
`;

export const AccountTermText = styled.span`
    font-size: 13px;
    font-weight: 400;
    color: #4a5568;
    display: block;
    margin-top: 1px;
    line-height: 1.4;
`;

export const TextButton = styled.button<{ $color: string }>`
    background: none;
    border: none;
    color: ${({ $color }) => $color};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 0;
    width: 100%;

    &:hover {
        opacity: 0.8;
    }
`;

export const WarningIconWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    gap: 8px;
`;

export const WarningTriangle = styled.span`
    font-size: 20px;
    line-height: 1;
`;

// ── Benefit cards (accept confirmation modal) ────────────

export const BenefitsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

export const RaffleBanner = styled.div<{ $color: string }>`
    width: 100%;
    border-radius: 10px;
    padding: 12px 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 8px;
    gap: 12px;
    background: linear-gradient(
        135deg,
        ${({ $color }) => $color}33 0%,
        ${({ $color }) => $color}1A 100%
    );
    border: 1px solid ${({ $color }) => $color}33;
    color: ${({ $color }) => $color};
`;

export const RaffleIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const RaffleTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const RaffleTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: inherit;
    line-height: 1.3;

    strong {
        font-weight: 800;
    }
`;

export const RaffleSubtitle = styled.span`
    font-size: 12px;
    color: #4a5568;
    line-height: 1.3;
`;

export const BenefitCardsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    width: 100%;
`;

export const BenefitCard = styled.div<{ $color: string }>`
    border-radius: 10px;
    padding: 12px;
    background-color: ${({ $color }) => $color}1A;
    border: 1px solid ${({ $color }) => $color}22;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 120px;
`;

export const BenefitCardIcon = styled.div<{ $color: string }>`
    color: ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const BenefitCardAmount = styled.span<{ $color: string }>`
    font-size: 14px;
    color: ${({ $color }) => $color};
    font-weight: 600;
    line-height: 1.2;

    strong {
        display: block;
        font-weight: 800;
        font-size: 18px;
    }
`;

export const BenefitCardDescription = styled.span`
    font-size: 12px;
    color: #4a5568;
    line-height: 1.3;
`;

export const BenefitsFooterText = styled.p`
    font-size: 11px;
    color: #718096;
    margin: 0;
    line-height: 1.4;

    em {
        font-style: italic;
    }
`;

export const DualEyebrow = styled.div`
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.4px;
    color: #718096;
    text-transform: uppercase;
`;

export const DualTitle = styled.h1<{ $color: string }>`
    font-size: 24px;
    font-weight: 700;
    color: ${({ $color }) => $color};
    margin: 6px 0 0;
    line-height: 1.2;
    letter-spacing: -0.2px;
`;

export const DualSubtitle = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 8px 0 0;
    line-height: 1.5;

    strong {
        font-weight: 700;
        color: #2d3748;
    }
`;

export const DualHeaderBlock = styled.div`
    width: 100%;
`;

export const Segmented = styled.div<{ $color: string }>`
    width: 100%;
    display: flex;
    background: ${({ $color }) => $color}11;
    border-radius: 12px;
    padding: 4px;
    border: 1px solid ${({ $color }) => $color}22;
    box-sizing: border-box;
`;

export const SegmentBtn = styled.button<{ $active: boolean; $color: string }>`
    flex: 1;
    padding: 10px 8px;
    border-radius: 9px;
    border: none;
    cursor: pointer;
    background: ${({ $active }) => ($active ? '#ffffff' : 'transparent')};
    box-shadow: ${({ $active }) => ($active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none')};
    color: ${({ $active, $color }) => ($active ? $color : '#718096')};
    font-weight: 700;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-family: inherit;
`;

export const RecommendedTag = styled.span`
    font-size: 9.5px;
    font-weight: 700;
    background: #E3F3E8;
    color: #1B7A4A;
    padding: 2px 6px;
    border-radius: 8px;
    letter-spacing: 0.4px;
`;

export const ChoiceCard = styled.div<{ $color: string; $highlight: boolean }>`
    width: 100%;
    border: 1.5px solid ${({ $color, $highlight }) => ($highlight ? $color : '#edf2f7')};
    border-radius: 12px;
    background: ${({ $color, $highlight }) => ($highlight ? `${$color}11` : '#ffffff')};
    padding: 16px;
    box-sizing: border-box;
`;

export const ChoiceCardHeader = styled.div<{ $color: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    color: ${({ $color }) => $color};
    font-size: 16px;
    font-weight: 700;
`;

export const ChoiceRow = styled.div<{ $color: string; $highlight: boolean; $last: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: ${({ $color, $highlight, $last }) =>
        $last ? 'none' : `1px solid ${$highlight ? `${$color}33` : '#edf2f7'}`};
`;

export const ChoiceRowLabel = styled.span<{ $emphasis: boolean }>`
    font-size: 13px;
    color: #4a5568;
    font-weight: ${({ $emphasis }) => ($emphasis ? 600 : 400)};
`;

export const ChoiceRowValue = styled.span<{ $color: string; $emphasis: boolean }>`
    font-size: ${({ $emphasis }) => ($emphasis ? '17px' : '14px')};
    font-weight: ${({ $emphasis }) => ($emphasis ? 700 : 600)};
    color: ${({ $color, $emphasis }) => ($emphasis ? $color : '#2d3748')};
    font-variant-numeric: tabular-nums;
    text-align: right;
`;

export const CoveredRisksBlock = styled.div<{ $color: string }>`
    width: 100%;
    background: ${({ $color }) => $color}11;
    border: 1px solid ${({ $color }) => $color}33;
    border-radius: 12px;
    padding: 14px;
    box-sizing: border-box;
`;

export const CoveredRisksHeaderRow = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-start;
`;

export const CoveredRisksIcon = styled.div<{ $color: string }>`
    color: ${({ $color }) => $color};
    margin-top: 2px;
    flex-shrink: 0;
`;

export const CoveredRisksTitle = styled.div<{ $color: string }>`
    font-size: 16px;
    font-weight: 700;
    color: ${({ $color }) => $color};
    line-height: 1.2;
`;

export const CoveredRisksOptionalLabel = styled.div`
    font-size: 12px;
    color: #718096;
    margin-top: 2px;
`;

export const CoveredRisksCopy = styled.div`
    font-size: 13px;
    color: #2d3748;
    margin-top: 8px;
    line-height: 1.45;

    strong {
        font-weight: 700;
    }
`;

export const CoveredRisksToggle = styled.button<{ $color: string }>`
    margin-top: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
    border: 1px solid ${({ $color }) => $color}55;
    border-radius: 8px;
    padding: 10px 12px;
    cursor: pointer;
    color: ${({ $color }) => $color};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
`;

export const CoveredRisksChevron = styled.span<{ $open: boolean }>`
    display: inline-flex;
    transition: transform 0.2s ease;
    transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0)')};
`;

export const CoveredRisksCoverageList = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const CoveredRisksCoverageItem = styled.div<{ $color: string }>`
    background: #ffffff;
    border: 1px solid ${({ $color }) => $color}33;
    border-radius: 8px;
    padding: 10px 12px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
`;

export const CoveredRisksCoverageCheck = styled.span`
    color: #1B7A4A;
    margin-top: 1px;
    flex-shrink: 0;
    display: inline-flex;
`;

export const CoveredRisksCoverageTitle = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #2d3748;
    line-height: 1.25;
`;

export const CoveredRisksCoverageDesc = styled.div`
    font-size: 12px;
    color: #4a5568;
    margin-top: 2px;
    line-height: 1.35;
`;

// ── FGTS Warranty Accordion ───────────────────────────────

export const FgtsAccordion = styled.div<{ $color: string }>`
    width: 100%;
    border: 1px solid ${({ $color }) => $color}33;
    background: ${({ $color }) => $color}11;
    border-radius: 14px;
    overflow: hidden;
    flex-shrink: 0;
`;

export const FgtsHeader = styled.button<{ $color: string }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 11px 14px;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: left;
    font-family: inherit;
`;

export const FgtsHeaderIcon = styled.span<{ $color: string }>`
    color: ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const FgtsTitle = styled.span<{ $color: string }>`
    flex: 1;
    font-weight: 700;
    font-size: 15px;
    color: ${({ $color }) => $color};
    line-height: 1.3;
`;

export const FgtsChevron = styled.span<{ $color: string; $open: boolean }>`
    color: ${({ $color }) => $color};
    transition: transform 0.25s ease;
    transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
    display: flex;
    flex-shrink: 0;
`;

export const FgtsBody = styled.div<{ $open: boolean }>`
    display: grid;
    grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
    transition: grid-template-rows 0.3s ease;

    > .inner {
        overflow: hidden;
    }
`;

export const FgtsIntro = styled.p`
    margin: 0;
    margin-bottom: 16px;
    padding: 0 16px;
    font-size: 13px;
    line-height: 1.5;
    color: #4a5568;
`;

export const FgtsRows = styled.div`
    padding: 0 16px 8px;
`;

export const FgtsRow = styled.div<{ $color: string }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 13px 0;
    border-top: 1px solid ${({ $color }) => $color}33;
    font-size: 13px;
`;

export const FgtsRowLabel = styled.span`
    color: #718096;
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

export const FgtsInfoWrap = styled.span`
    position: relative;
    display: inline-flex;
`;

export const FgtsInfoButton = styled.button<{ $color: string }>`
    position: relative;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    color: ${({ $color }) => $color};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        display: block;
    }

    /* Expand the hit area without affecting layout */
    &::before {
        content: '';
        position: absolute;
        inset: -10px;
    }
`;

export const FgtsTooltip = styled.div<{ $show: boolean }>`
    position: fixed;
    width: 210px;
    max-width: calc(100vw - 16px);
    padding: 9px 11px;
    border-radius: 9px;
    background: #2d3748;
    color: #ffffff;
    font-size: 11.5px;
    font-weight: 400;
    line-height: 1.45;
    text-align: left;
    box-shadow: 0 8px 22px rgba(15, 23, 42, 0.22);
    opacity: ${({ $show }) => ($show ? 1 : 0)};
    visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
    transform: ${({ $show }) => ($show ? 'translateY(-100%)' : 'translateY(calc(-100% + 4px))')};
    transition: opacity 0.15s ease, transform 0.15s ease;
    z-index: 9999;
    pointer-events: none;
`;

export const FgtsTooltipArrow = styled.span`
    position: absolute;
    top: 100%;
    border: 6px solid transparent;
    border-top-color: #2d3748;
    transform: translateX(-50%);
`;

export const FgtsRowValue = styled.span`
    color: #2d3748;
    font-weight: 700;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
`;
